module.exports = __webpack_public_path__ + "src/assets/img/kitchen_header.42cc8192.jpg";